export const MEDLEVE_HOW_IT_WORKS_STEPS = [
  {
    title: 'Consulta',
    description:
      'Converse com um médico diretamente pela plataforma, de forma rápida e segura. Escolha entre atendimento por mensagem ou por videochamada.',
    footnote: '*Se optar por vídeo, o atendimento é ao vivo, com tempo médio de espera de até 5 minutos.'
  },
  {
    title: 'Prescrição',
    description:
      'Se houver indicação de tratamento medicamentoso, você receberá sua receita digital, válida em todo o Brasil. Você pode comprar seu medicamento em nossa plataforma ou na farmácia de sua preferência.'
  },
  {
    title: 'Acompanhamento',
    description:
      'Seu histórico de consultas e prescrições fica disponível na plataforma, facilitando a continuidade do seu tratamento sempre que necessário.'
  }
] as const
